import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { FormattedMessage } from '@flipster/i18n';
import { Button } from '@flipster/react/design-system/button';
import { TextButton } from '@flipster/react/design-system/text-button';
import { css } from '@flipster/styled-system/css';
import { hstack, stack } from '@flipster/styled-system/patterns';

import { editProfileBunja } from '../../../../bunja';
import { CommunitySizeInput } from '../shared/community-size-input';
import { socialXBunja } from './bunja';

export function SocialXSection() {
  const t = useTranslations();
  const { isMasterTraderAtom } = useBunja(editProfileBunja);
  const { isLoadingAtom, xConnectionAtom, connect, disconnect } = useBunja(socialXBunja);
  const isMasterTrader = useAtomValue(isMasterTraderAtom);
  const isLoading = useAtomValue(isLoadingAtom);
  const connection = useAtomValue(xConnectionAtom);
  return (
    <div className={stack({ gap: 12, w: '100%', textStyle: 'Text/L/Strong', color: 'content.default.level-5' })}>
      <div className={hstack({ justify: 'space-between' })}>
        <div className={hstack({ justify: 'center', gap: 4 })}>
          <p>
            <FormattedMessage id='Autogen_common.r251126.s_Connect_X_to_Flipster' />
          </p>
        </div>
        {!connection && (
          <Button
            hierarchy='primary'
            color='neutral'
            label={t('Autogen_common.r251126.s_Connect')}
            onClick={connect}
            isLoading={isLoading}
            withSpinner
          />
        )}
      </div>
      {connection && (
        <div className={stack({ gap: 8, align: 'flex-start' })}>
          <div className={hstack({ justify: 'center', gap: 4 })}>
            <p className={css({ textStyle: 'Text/L/Regular' })}>
              <FormattedMessage id='Autogen_common.r251126.s_Connected_as' />
            </p>
            <p>@{connection.username}</p>
          </div>
          <TextButton color='passive' label={t('Autogen_common.r251126.s_Disconnect')} onClick={disconnect} />
        </div>
      )}
      {isMasterTrader && <CommunitySizeInput type='X' />}
    </div>
  );
}
